import { message } from "antd";
import { store } from "@/store";
import { HashRouter } from "react-router-dom";

const router: any = new HashRouter({});

const querystring = (obj: any = {}) => {
  return new URLSearchParams(Object.entries(obj)).toString();
};

const fn = (url: string, options: any, method: string = "get") => {
  const searchStr = options ? querystring(options) : "";
  let initObj: any = {};
  const { token = "" } = store.getState().storeData.userInfo || {};
  if (method == "get") {
    url += searchStr ? "?" + searchStr : searchStr;
    initObj = {
      method: method,
      credentials: "include", // 强制携带cookie
    };
  } else {
    initObj = {
      method: method,
      credentials: "include", // 强制携带cookie
      headers: new Headers({
        "Content-Type": "application/json",
        token,
      }),
      body: searchStr,
    };
  }

  return fetch(url, initObj)
    .then((response) => {
      return response.json();
    })
    .then((res: any) => {
      if (res && res.code === 101) {
        message.error(res.msg);
        router.history.replace({ pathname: "/index/home" });
        return;
      }
      return res;
    });
};

const get = (url: string, body?: any) => {
  return fn(url, body, "get");
};

const post = (url: string, body?: any) => {
  return fn(url, body, "post");
};

export default {
  get,
  post,
};
